import $ from 'jquery';
import Handlebars from '../../common/templates';
import SelectedJobsState from './SelectedJobsState';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  basket: '.js-basket',
  basketSelectedWork: '.v2-basket-selected-work',
  basketPriceAdjustments: '.basket-price-adjustments',
  basketFooter: '.v2-basket-footer',
  prices: '.prices',
  loader: '.js-loader',
  manualQuote: '#manual-quote',
  customQuote: '.js-custom-quote',
  priceAdjustment: '.price-adjustment',
  basketExtras: '.basket-extras',
  quoteWrapper: 'div.quote',
};

const TEMPLATES = {
  workItem: '#v2-work-item-template',
  priceAdjustment: '#v2-price-adjustment-template',
  workItemParts: '#v2-work-item-parts-template',
  noWorkItemParts: '#v2-work-item-no-parts-template',
};

export default class WorkBasket {
  constructor() {
    this.basket = $(SELECTORS.basket);
    this.basketSelectedWork = $(SELECTORS.basketSelectedWork);
    this.basketPriceAdjustments = $(SELECTORS.basketPriceAdjustments);
    this.quoteWrapper = this.basket.find(SELECTORS.quoteWrapper);
    this.selectedJobsState = new SelectedJobsState();
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('jobs:added', (data) => {
      this.add(data.job.work_item_id, data.job.description);
    });
    EventBus.on('jobs:removed', (data) => {
      this.remove(data.id);
    });
    EventBus.on('jobs:cleared', () => {
      this.clearWorkItems();
    });
    EventBus.on('quote:fetching-start', () => this.startFetchingQuote());
    EventBus.on('quote:fetching-end', (data) => this.endFetchingQuote(data));
  }

  add(id, description) {
    const workItemTemplate = Handlebars.getTemplate(TEMPLATES.workItem);
    const markUp = workItemTemplate({ id: id, description: description });

    this.basketSelectedWork.append(markUp);
    this._showSelectedWork();
  }

  remove(id) {
    this.basketSelectedWork.find(`.js-work-item[data-id="${id}"]`).remove();
    this._hideSelectedWork();
  }

  clearWorkItems() {
    this.basketSelectedWork.empty();
  }

  startFetchingQuote() {
    this.quoteWrapper.addClass('fetching-quote');
    EventBus.emit('basket:fetching-quote', {});

    this.basket.find(SELECTORS.prices).addClass('hidden');
    this.basket.find(SELECTORS.loader).removeClass('hidden');
    this.basket.find(SELECTORS.manualQuote).addClass('hidden');

    if (!this.selectedJobsState.selectedJobs().length) {
      $(SELECTORS.basketFooter).addClass('hidden');
    }

    $(SELECTORS.customQuote).prop('disabled', true);
    $(`${SELECTORS.basketPriceAdjustments} ${SELECTORS.priceAdjustment}`).addClass('awaiting-price');
    $(SELECTORS.basketExtras).addClass('hidden');
  }

  endFetchingQuote(data) {
    this.quoteWrapper.removeClass('fetching-quote');

    this.basket.find(SELECTORS.prices).removeClass('hidden');
    this.basket.find(SELECTORS.loader).addClass('hidden');
    $(SELECTORS.customQuote).prop('disabled', false);

    if (this.selectedJobsState.selectedJobs().length) {
      $(SELECTORS.basketFooter).removeClass('hidden');
    } else {
      $(SELECTORS.basketFooter).addClass('hidden');
    }

    if (data?.quote) {
      this.updateQuote(data.quote);
    }

    EventBus.emit('basket:end-fetching-quote', {});
  }

  updateQuote(data) {
    this._renderWorkItems(data);
    this._renderPriceAdjustments(data);

    this._updateMotPricingMessage(data);
    this._updateCollectionAndDeliveryMessage(data);
    this._updateWarrantyMessage(data);

    this.basketSelectedWork.removeClass('hidden');
  }

  _showSelectedWork() {
    this.basketSelectedWork.removeClass('no-work');
  }

  _hideSelectedWork() {
    if (this.selectedJobsState.selectedJobs().length === 0) {
      this.basketSelectedWork.addClass('no-work');
    }
  }

  _renderWorkItems(data) {
    const items = data['quote_items'];

    for (const id in items) {
      if (items.hasOwnProperty(id)) {
        const item = items[id];
        item.id = id;
        this._renderWorkItem(item);
      }
    }
  }

  _updateMotPricingMessage(data) {
    if (data['dealership_price']) {
      this.basketSelectedWork.find('.js-work-item[data-id=3188] .basket-pricing-message').removeClass('hidden');
    } else {
      this.basketSelectedWork.find('.basket-pricing-message').addClass('hidden');
    }
  }

  _renderPriceAdjustments(data) {
    const adjustments = data['price_adjustments'];
    this._clearPriceAdjustments();
    adjustments?.forEach((adjustment) => {
      this._renderPriceAdjustment(adjustment);
    });
  }

  _updateCollectionAndDeliveryMessage(data) {
    const collectionDeliveryExtra = $('.free-collection-and-delivery');
    data['show_collection_and_delivery_message'] ? collectionDeliveryExtra.removeClass('hidden') : collectionDeliveryExtra.addClass('hidden');
  }

  _updateWarrantyMessage(data) {
    const warrantyExtra = $('.free-warranty');
    data['show_warranty_message'] ? warrantyExtra.removeClass('hidden') : warrantyExtra.addClass('hidden');
  }

  _clearPriceAdjustments() {
    this.basketPriceAdjustments.empty();
  }

  _renderWorkItem(workItem) {
    const workItemElement = this.basketSelectedWork.find(`.v2-work-item[data-id="${workItem.id}"]`);
    if (!workItemElement.length > 0) return;

    const itemPrice = workItemElement.find('.price').children('span');
    const itemLabour = workItemElement.find('.labour');
    const itemParts = workItemElement.find('.parts');

    itemPrice.text(workItem.price);
    itemLabour.removeClass('hidden').children('span').text(workItem.labour_time);

    itemParts.empty();
    if (this._workItemHasParts(workItem)) {
      itemParts.append(this._renderParts(workItem));
    } else {
      itemParts.append(this._renderNoParts());
    }

    workItemElement.removeClass('awaiting-price');
  }

  _renderPriceAdjustment(adjustment) {
    const priceAdjustment = Handlebars.getTemplate(TEMPLATES.priceAdjustment)(adjustment);
    this.basketPriceAdjustments.append(priceAdjustment);
  }

  _workItemHasParts(workItem) {
    return workItem.parts_included.length > 0 || workItem.parts_already_included.length > 0 || workItem.parts_unquoted.length > 0;
  }

  _renderParts(workItem) {
    const workItemPartsTemplate = Handlebars.getTemplate(TEMPLATES.workItemParts);
    return workItemPartsTemplate(workItem);
  }

  _renderNoParts() {
    const workItemNoPartsTemplate = Handlebars.getTemplate(TEMPLATES.noWorkItemParts);
    return workItemNoPartsTemplate();
  }
}
